export default __webpack_public_path__ + "static/media/Logo_AiLogistic.4c851733.jpg";